import React from 'react';
import PropTypes from 'prop-types';

import HamburgerMenu from '../HamburgerMenu';
import DashboardNavigationControls from './DashboardNavigationControls';

import './DashboardNavigation.scss';

function DashboardNavigation({ isAnonymousUser, isAEMock, isPendoResourceCenterEnabled }) {
  return (
    <nav id="dashboard-navigation" title="Dashboard menu">
      <ul className="dashboard-icon-alignment">
        <DashboardNavigationControls
          isAnonymousUser={isAnonymousUser}
          isAEMock={isAEMock}
          isPendoResourceCenterEnabled={isPendoResourceCenterEnabled}
        />
        <HamburgerMenu isAnonymousUser={isAnonymousUser} isAEMock={isAEMock} />
      </ul>
    </nav>
  );
}

DashboardNavigation.propTypes = {
  isAnonymousUser: PropTypes.bool,
  isAEMock: PropTypes.bool,
  isPendoResourceCenterEnabled: PropTypes.bool,
};

export default DashboardNavigation;
